import { render, staticRenderFns } from "./tutorial.vue?vue&type=template&id=a80cebae&scoped=true&"
import script from "./tutorial.vue?vue&type=script&lang=ts&"
export * from "./tutorial.vue?vue&type=script&lang=ts&"
import style0 from "./tutorial.vue?vue&type=style&index=0&id=a80cebae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80cebae",
  null
  
)

export default component.exports